import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

const FaqSection = () => {
    const faqItems = [
        {
            id: 1,
            question: "Comment puis-je trouver une aide ménagère qualifiée ?",
            answer: "Notre plateforme vous permet de rechercher des profils vérifiés selon vos critères (disponibilité, compétences, localisation). Vous pouvez consulter les évaluations et profils avant de faire votre choix."
        },
        {
            id: 2,
            question: "Comment sont vérifiées les aides ménagères ?",
            answer: "Toutes nos aides ménagères passent par un processus rigoureux : vérification d'identité, vérification des antécédents, entretien personnel et validation des compétences."
        },
        {
            id: 3,
            question: "Puis-je modifier mes besoins après avoir engagé une aide ménagère ?",
            answer: "Oui, vous pouvez ajuster les horaires et tâches en accord avec l'aide ménagère. Driven Home Services peut faciliter cette négociation si nécessaire."
        },
        {
            id: 4,
            question: "Comment fonctionne le paiement ?",
            answer: "Le paiement s'effectue via notre plateforme sécurisée. Vous payez Driven Home Services qui reverse ensuite à l'aide ménagère après déduction de notre commission."
        },
        {
            id: 5,
            question: "Que faire en cas de problème avec l'aide ménagère ?",
            answer: "Notre service client est disponible pour médier les conflits. En cas de problème sérieux, nous pouvons vous aider à trouver un remplacement rapidement."
        },
        {
            id: 6,
            question: "Puis-je engager une aide ménagère à temps plein ?",
            answer: "Oui, nous proposons des contrats flexibles adaptés à tous les besoins, du service ponctuel au temps complet."
        }
    ];

    const [activeIndex, setActiveIndex] = useState(null);

    const handleClick = (index) => {
        setActiveIndex(index === activeIndex ? null : index);
    };

    // Styles inline
    const accordionSingleStyle = {
        border: '1px solid #e0e0e0',
        padding: '15px',
        marginBottom: '15px',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        borderRadius: '8px'
    };

    const activeStyle = {
        backgroundColor: '#f8f9fa',
        borderColor: '#007bff',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
    };

    return (
        <section style={{ backgroundColor: '#fff', padding: '120px 0', position: 'relative' }}>
            <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
                <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', gap: '30px' }}>
                    <div style={{ flex: '1 1 300px' }}>
                        <div style={{ position: 'relative', width: '100%' }}>
                            <img src="assets/images/faq/faq.png" alt="Driven Home Services FAQ" style={{ width: '100%', borderRadius: '8px' }} />
                            <div style={{ border: '1px solid #e0e0e0', backgroundColor: '#fff', padding: '25px', textAlign: 'center', marginTop: '25px', borderRadius: '8px' }}>
                                <div style={{ border: 'none', margin: 'auto', width: '60px', height: '60px', borderRadius: '50%', backgroundColor: '#1d8d36', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <i className="fa-solid fa-headphones" style={{ color: '#fff', fontSize: '24px' }}></i>
                                </div>
                                <div style={{ marginTop: '15px' }}>
                                    <h6 style={{ color: '#333', marginBottom: '10px', fontSize: '18px' }}>Besoin d'aide ?</h6>
                                    <p style={{ color: '#666', fontSize: '15px', lineHeight: '1.5' }}>
                                        Notre équipe est disponible pour répondre à toutes vos questions sur nos services.
                                    </p>
                                    <Link to="/contact" style={{ textDecoration: 'none' }}>
                                        <button style={{
                                            backgroundColor: '#1d8d36',
                                            color: 'white',
                                            border: 'none',
                                            padding: '10px 20px',
                                            borderRadius: '5px',
                                            marginTop: '15px',
                                            cursor: 'pointer'
                                        }}>
                                            Contacter le support
                                        </button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={{ flex: '2 1 600px' }}>
                        <div style={{ marginBottom: '30px' }}>
                            <h2 style={{ color: '#333', fontSize: '28px', marginBottom: '15px' }}>Questions fréquentes</h2>
                            <p style={{ color: '#666', fontSize: '16px' }}>
                                Trouvez des réponses aux questions les plus courantes sur nos services.
                            </p>
                        </div>
                        <div>
                            {faqItems.map((item, index) => (
                                <div
                                    key={item.id}
                                    style={{
                                        ...accordionSingleStyle,
                                        ...(activeIndex === index ? activeStyle : {}),
                                    }}
                                    onClick={() => handleClick(index)}
                                    tabIndex={0}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            handleClick(index);
                                        }
                                    }}
                                >
                                    <h5 style={{
                                        margin: 0,
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        fontSize: '18px',
                                        fontWeight: '500'
                                    }}>
                                        <button
                                            style={{
                                                border: 'none',
                                                background: 'none',
                                                width: '100%',
                                                textAlign: 'left',
                                                cursor: 'pointer',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                padding: '5px 0'
                                            }}
                                            type="button"
                                        >
                                            {item.question}
                                            {activeIndex === index ? (
                                                <FaChevronUp style={{ marginLeft: '15px', color: '#007bff' }} />
                                            ) : (
                                                <FaChevronDown style={{ marginLeft: '15px', color: '#666' }} />
                                            )}
                                        </button>
                                    </h5>
                                    <div style={{
                                        display: activeIndex === index ? 'block' : 'none',
                                        marginTop: '15px',
                                        color: '#555',
                                        lineHeight: '1.6',
                                        padding: '0 10px'
                                    }}>
                                        <p>{item.answer}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FaqSection;